export const FieldConverter = {
  booleanToString: (value: boolean | undefined | null): string | null => {
    if (value === true) return "YES";
    if (value === false) return "NO";
    return null;
  },

  stringToBoolean: (value: string | null | undefined): boolean | undefined => {
    if (value === "YES") return true;
    if (value === "NO") return false;
    return undefined;
  },

  stringToBooleanOrNull: (value: string | null | undefined): boolean | null => {
    if (value === "YES") return true;
    if (value === "NO") return false;
    return null;
  },

  stringToNumber: (value: string | null | undefined): number | undefined => {
    if (!value || value.trim() === "") return undefined;
    const parsed = Number(value);
    return Number.isNaN(parsed) ? undefined : parsed;
  },

  numberToString: (value: number | null | undefined): string | undefined => {
    if (value === null || value === undefined) return undefined;
    return String(value);
  },

  booleanToStringWithSpecialCase: (value: unknown): string | undefined => {
    if (value === "YES") return "YES";
    if (value === "NO") return "NO";
    if (value === true) return "YES";
    if (value === false) return "NO";
    return undefined;
  },
} as const;

export type ConversionRule = {
  field: string;
  type: "boolean" | "number" | "string" | "date";
  required?: boolean;
};

export const INSURANCE_VERIFICATION_FIELD_RULES: ConversionRule[] = [
  { field: "hasOrthodonticCoverage", type: "string" },
  { field: "hasOrthoPlanDeductible", type: "boolean" },
  { field: "hasOrthoWaitingPeriod", type: "boolean" },
  { field: "orthoLifetimeMaxBenefit", type: "number" },
  { field: "orthoAmountUsed", type: "number" },
  { field: "orthoAmountRemaining", type: "number" },
  { field: "orthoPercentagePlanPays", type: "number" },
  { field: "orthoAgeLimit", type: "number" },
  { field: "orthoInitialPaymentPercentage", type: "number" },
  { field: "orthoDeductibleRemaining", type: "number" },
  { field: "effectiveDate", type: "date" },
  { field: "terminationDate", type: "date" },
  { field: "orthoDateOfWaitingPeriod", type: "date" },
];

export const convertStringToBoolean = FieldConverter.stringToBooleanOrNull;
export const booleanToString = FieldConverter.booleanToStringWithSpecialCase;
